import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthenticationSelectors } from '../authentication';

export const tenantInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const store = inject(Store);

  const plant = store.selectSnapshot(AuthenticationSelectors.activePlant);
  const tenant = store.selectSnapshot(AuthenticationSelectors.activeTenant);
  const plants = store.selectSnapshot(AuthenticationSelectors.plants);

  let modified = req;

  if (!plant || req.url.includes('auth.prod.orion.cz.foxconn.com')) {
    return next(req);
  }

  // Single plant
  if (plant !== 'MULTI') {
    modified = req.clone({
      headers: req.headers.set('Request-Tenants', plant),
    });
    return next(modified);
  }

  // MULTI + activeTenant chosen
  if (tenant) {
    modified = req.clone({
      headers: req.headers.set('Request-Tenants', tenant),
    });
    return next(modified);
  }

  // MULTI + no tenant → combine list of plants
  if (Array.isArray(plants) && plants.length > 0) {
    const codes = plants
      .map((p): string => p.Code)
      .filter((code): boolean => !!code)
      .join(',');

    modified = req.clone({
      headers: req.headers.set('Request-Tenants', codes),
    });
  }

  return next(modified);
};
